/**
 * Book-filter keys the user can pick don't always match the bookie keys
 * the arb feed emits; canonicalize both sides before comparing.
 */
const BOOKIE_FILTER_ALIASES: Record<string, string> = {
  hard_rock: "hardrockbet",
  hardrockbet: "hardrockbet",
  caesars: "williamhill_us",
  williamhillus: "williamhill_us",
  williamhill_us: "williamhill_us",
};

export function normalizeBookieKey(bookie: string): string {
  const normalized = bookie?.trim().toLowerCase().replace(/\s+/g, "_") ?? "";
  if (normalized.startsWith("hardrockbet_")) return "hardrockbet";
  return BOOKIE_FILTER_ALIASES[normalized] ?? normalized;
}
